import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { HttpClient } from '@angular/common/http';
import { GenericService } from "../../commons/generic.service";
import { environment } from "environments/environment";

@Injectable()
export class CarrosselService extends GenericService {

    private relativePath: string = 'api/videos';
    private relativePathVideosAoVivo: string = 'api/videosaovivo';
    constructor(http: HttpClient) {
        super(http);
    }

    getVideos(): Observable<any> {
        return this.http.get(environment.urlSessaoJulgamentoAPI + this.relativePath + '/sessao');
    }

    getVideosAoVivo(): Observable<any> {
        return this.http.get(environment.urlSessaoJulgamentoAPI + this.relativePathVideosAoVivo + '/videosaovivo');
    }

    getRelatores(): Observable<any> {
        return this.http.get(this.relativePathVideosAoVivo + '/relatores');
    }

    getVideosAoVivoViaBack(): Observable<any> {
        return this.getMethod('v1/videosaovivo');
    }
}
